// @ts-nocheck

import React from 'react';
import { navigate } from '../../../lib/routerAdapter';
import notification from 'antd/lib/notification';
import { connect } from 'react-redux';

import Input from 'antd/lib/input/Input';
import styled from 'styled-components';
import Button from 'antd/lib/button';
import moment from 'moment';
import { DatePicker } from '../../../components/ant/DatePicker';

import { Header, Section } from '../../../components/layout';
import {
  cleanVehicle,
  fetchVehicle,
  updateVehicle } from
'../../../ducks/vehicle';


import Grid, { GridItem } from '../../../components/layout/Grid';
import Form from '../../../components/Form';
import { formatDateTimeToISOString as changeDate } from './../../../lib/helpers';
import { getDisabledDate, getDisabledPlannedDate } from './../lib';
import { notificationLoading } from './../../../components/Notifications';
import CancelButton from '../../../components/CancelButton';

const StyledSection = styled(Section)`
  padding: 16px;
`;
const Footer = styled(Section)`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;









class Gpm extends React.Component {
  async componentDidMount() {
    const { vehicleId } = this.props;
    await this.props.cleanVehicle();
    try {
      await this.props.fetchVehicle(vehicleId);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  }

  onSubmit = async (values) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      await this.props.updateVehicle(values);
      notification.success({
        message: 'Успешно сохранено',
        description: 'Изменения успешно сохранены'
      });
      navigate(`/vehicles/${values.id}/documentation/gpm`);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  handleCancel = () => {
    navigate(`/vehicles/${this.props.vehicleId}/documentation/gpm`);
  };

  formatDate = (value) => {
    return value ? moment.utc(value) : null;
  };

  render() {
    const { vehicle = {} } = this.props;
    return (
      <>
        <Header left={vehicle && <h1>ГПМ {vehicle.licensePlate}</h1>} />
        <Form initialValues={vehicle || {}} onSubmit={this.onSubmit}>
          {(FormField, formikProps) => {
            const {
              handleSubmit,
              handleBlur,
              handleChange,
              setFieldValue,
              dirty
            } = formikProps;
            return (
              <form onSubmit={handleSubmit}>
                <StyledSection>
                  <Grid gutter="16px">
                    <GridItem>
                      <FormField name="gpmType" required label="Тип">
                        {(field) =>
                        <Input {...field} placeholder="Введите тип ГПМ" />
                        }
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField label="Модель" required name="gpmModel">
                        {({ value, name }) =>
                        <Input
                          placeholder="Введите модель ГПМ"
                          name={name}
                          value={value}
                          onChange={handleChange}
                          onBlur={handleBlur} />

                        }
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField
                        label="Регистрационный номер подъемного сооружения"
                        fast
                        required
                        name="gpmRegistrationNumber">

                        {(field) => <Input {...field} />}
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField
                        label="Заводской номер подъемного сооружения"
                        fast
                        required
                        name="gpmFactoryNumber">

                        {(field) => <Input {...field} />}
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField
                        label="Дата последней экспертизы"
                        required
                        name="lastExpertiseDate">

                        {({ value, name }) =>
                        <DatePicker
                          format="DD.MM.YYYY"
                          value={this.formatDate(value)}
                          onChange={(value, dateString) => {
                            setFieldValue(
                              name,
                              changeDate(value, dateString)
                            );
                          }}
                          disabledDate={(currentDate) =>
                          getDisabledDate(currentDate)
                          } />

                        }
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField
                        label="Дата последнего ТО приборов безопасности"
                        required
                        name="lastSafetyDeviceMaintenanceDate">

                        {({ value, name }) =>
                        <DatePicker
                          format="DD.MM.YYYY"
                          value={this.formatDate(value)}
                          onChange={(value, dateString) => {
                            setFieldValue(
                              name,
                              changeDate(value, dateString)
                            );
                          }}
                          disabledDate={(currentDate) =>
                          getDisabledDate(currentDate)
                          } />

                        }
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField
                        label="Планируемая дата экспертизы"
                        name="lastExpertisePlannedDate"
                        required>

                        {({ value, name }) =>
                        <DatePicker
                          format="DD.MM.YYYY"
                          value={this.formatDate(value)}
                          onChange={(value, dateString) => {
                            setFieldValue(
                              name,
                              changeDate(value, dateString)
                            );
                          }}
                          disabledDate={getDisabledPlannedDate} />

                        }
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField
                        required
                        label="Планируемая дата ТО приборов безопасности"
                        name="lastSafetyDeviceMaintenancePlannedDate">

                        {({ value, name }) =>
                        <DatePicker
                          format="DD.MM.YYYY"
                          value={this.formatDate(value)}
                          onChange={(value, dateString) => {
                            setFieldValue(
                              name,
                              changeDate(value, dateString)
                            );
                          }}
                          disabledDate={getDisabledPlannedDate} />

                        }
                      </FormField>
                    </GridItem>
                  </Grid>
                </StyledSection>
                <Footer>
                  <Button type="primary" htmlType="submit">
                    Сохранить
                  </Button>
                  <CancelButton dirty={dirty} onClick={this.handleCancel}>
                    Отменить
                  </CancelButton>
                </Footer>
              </form>);

          }}
        </Form>
      </>);

  }
}

export default connect(
  (state, props) => ({
    vehicle: state.vehicle,
    vehicleId: parseInt(props.vehicleId, 10)
  }),
  {
    fetchVehicle,
    cleanVehicle,
    updateVehicle
  }
)(Gpm);
